var render, staticRenderFns
import script from "./popconfirm.vue?vue&type=script&lang=js&"
export * from "./popconfirm.vue?vue&type=script&lang=js&"
import style0 from "./popconfirm.vue?vue&type=style&index=0&id=eced1f84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eced1f84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eced1f84')) {
      api.createRecord('eced1f84', component.options)
    } else {
      api.reload('eced1f84', component.options)
    }
    
  }
}
component.options.__file = "src/components/customPage/popconfirm.vue"
export default component.exports